export enum StoreTypename {
  UI = 'Store.Ui',
  ACTIVE_LESSON = 'Store.ActiveLesson',
  USER = 'User',
  TOUR = 'ToursSetting',
  RESOURCES = 'Resources',
  FAVORITE_RESOURCES = 'Favorite Resources',
  RESOURCE_FILTERS = 'Resource Filters',
  BOOK_CONTENT = 'Book Content',
  CUSTOM_TEACHING_ORDERS = 'Custom Teaching Orders',
  BOOK = 'Book',
  GROUP = 'Group',
  ASSIGNMENT = 'Assignment',
  USER_CLASSROOM = 'User Classroom',
  STUDENT_PROGRESS = 'Student Progress',
}

export enum ButtonSize {
  XLARGE = 140,
  LARGE = 120,
  MEDIUM = 100,
  SMALL = 80,
  XSMALL = 70,
}

export enum TYPOGRAPHY_TYPES {
  ASCENDER = 'ascender',
  DESCENDER = 'descender',
  PLAIN = 'plain',
}

export enum SCREEN_RESIZE_MEDIA_QUERY {
  IPAD = '(max-width:1024px)',
}

export enum AppRoutes {
  LETTER_BOOK = 'letter-book',
  LETTER_BOOKS = 'letter-books',
  PRACTICE_BOOK = 'practice-book',
  TEACHERS_GUIDE = 'teachers-guide',
  RESOURCES = 'resources',
  STUDENT_PRACTICE_BOOK = 'student-practice-book',
  LETTER_TEACHING = 'letter-teaching',
  CLASSROOM_BOOKS = 'classroom-books',
  ACTIVITY_SELECTION = 'activity-selection',
  REPORTS = 'reports',
  ASSIGNMENTS = 'assignments',
  HELP_AND_SUPPORT = 'help-and-support',
}

export enum LetterBookZoom {
  DEFAULT = 1,
  ZOOMED = 1.5,
}

export enum AppNames {
  WDT = 'wdt',
  GSS = 'gss',
}

export enum StudentPracticeBookLevel {
  Emerging = 'Emerging',
  Developing = 'Developing',
}

export enum Alignment {
  FLEX_START = 'flex-start',
  FLEX_END = 'flex-end',
  CENTER = 'center',
  SPACE_BETWEEN = 'space-between',
}

export enum LetterUniCodes {
  B = '\uE000',
  G = '\uE001',
  I = '\uE002',
  J = '\uE003',
  M = '\uE004',
  Y = '\uE005',
  g = '\uE006',
  j = '\uE014',
  q = '\uE015',
  u = '\uE00A',
}

export enum NoOfPages {
  ONE_PAGE = 1,
  TWO_PAGES = 2,
}

export enum SupportResourceType {
  TRAINING_VIDEOS = 'trainingVideos',
  SUPPORT_DOCUMENTS = 'supportDocuments',
}

export enum Settings {
  WELCOME = 'welcome',
  FREE_TRIAL = 'freeTrial',
  VIEWED_ASSIGNMENTS = 'viewedAssignments',
}

export enum PageTypes {
  Default,
  Activity,
  Pdf,
}

export const DEFAULT_FIRST_PAGE = {
  [PageTypes.Default]: 0,
  [PageTypes.Activity]: 4,
  [PageTypes.Pdf]: 1,
};

export enum PageViewType {
  OnePage = 1,
  TwoPage = 2,
}

export enum IconSizes {
  XS = 'xs',
  SM = 'sm',
  LG = 'lg',
  XL = 'xl',
}

export enum NavigationDirection {
  Next = 'Next',
  Previous = 'Previous',
}

export enum TourName {
  WELCOME = 'welcome',
}

export enum LocalStorage {
  CLASSROOM_ID = 'classroomid',
}
